export enum RegistrationOfEnergyProducerApplicationDocumentTypes {
  FeedInControllabilityContract = 'feed_in_controllability_contract',
  PhotoDocumentationOfInstalledGeneratorsAndConverters = 'photo_documentation_of_installed_generators_and_converters',
  BafaNoticeOfAuthorization = 'bafa_notice_of_authorization',
  RequestForMeterMounting = 'request_for_meter_mounting',
}
